import { PLAN_META } from "@/lib/planFeatures";

const STYLES = {
  growth: "border-brand/30 bg-brand/10 text-brand-ink",
  scale: "border-foreground/20 bg-secondary text-foreground",
  fund_manager: "border-foreground bg-primary text-primary-foreground",
};

export const PlanBadge = ({ plan, className = "", testId = `plan-tag-${plan}` }) => (
  <span
    data-testid={testId}
    className={`tenx-plan-badge inline-flex shrink-0 items-center rounded-full border px-1.5 py-px text-[9px] font-bold uppercase tracking-wide ${STYLES[plan] || STYLES.growth} ${className}`}
  >
    {PLAN_META[plan]?.name || plan}
  </span>
);
